import { getGameConfig } from '../../../config/gameConfig';
import { runAssistantMoves } from '../../../tick/assistant';
import { runConstructionTick } from '../../../tick/construction';
import { runConsumptionTick } from '../../../tick/consumption';
import { runFarmTick } from '../../../tick/farm';
import { runFishingTick } from '../../../tick/fishing';
import { runForesterTick } from '../../../tick/forester';
import { runGrabToolTick } from '../../../tick/grabTool';
import { runHuntTick } from '../../../tick/hunt';
import { runLumberCampTick } from '../../../tick/lumberCamp';
import { runMasonryTick } from '../../../tick/masonry';
import { runQuarryTick } from '../../../tick/quarry';
import { runSawmillTick } from '../../../tick/sawmill';
import { runTreeTick } from '../../../tick/trees';
import { runWildlifeTick } from '../../../tick/wildlife';
import { runPopulationTick } from '../../../tick/population';
import { runCharcoalTick } from '../../../tick/charcoal';
import { runIronMineTick } from '../../../tick/ironMine';
import { runSmokehouseTick } from '../../../tick/smokehouse';
import { runSmelterTick } from '../../../tick/smelter';
import { runWeaverTick } from '../../../tick/weaver';
import { runBlacksmithTick } from '../../../tick/blacksmith';
import { runGoldMineTick } from '../../../tick/goldMine';
import { runMintTick } from '../../../tick/mint';
import { addInventory, removeInventory } from './inventoryManager';
import { ensureHouses } from '../sync/houseSync';
import { syncJobsFromPeople } from '../sync/jobsSync';
import { advanceResourceStatsTick } from '../sync/resourceStatsSync';
import { getResourceStatsWindow } from '../factory/resourceStatsFactory';
import type { Settlement } from '../types';

export function runLumberCamp(settlement: Settlement): number {
    if (settlement.buildings.lumberjack.qty <= 0) return 0;
    const output = settlement.jobs.lumberjacks * 2 + settlement.jobs.assistants;
    addInventory(settlement, 'wood', output);
    return output;
}

export function runSawmill(settlement: Settlement): number {
    if (settlement.buildings.sawmill.qty <= 0) return 0;
    const capacity = settlement.jobs.sawmillers * 2;
    const output = Math.min(settlement.inventory.wood, capacity);
    removeInventory(settlement, 'wood', output);
    addInventory(settlement, 'planks', output);
    return output;
}

export function tickSettlementProduction(settlement: Settlement, tickIndex: number): boolean {
    const resourceWindow = getResourceStatsWindow(getGameConfig());
    advanceResourceStatsTick(settlement, resourceWindow, tickIndex);
    let changed = false;

    ensureHouses(settlement);
    syncJobsFromPeople(settlement);

    if (runGrabToolTick(settlement)) changed = true;

    if (runWildlifeTick(settlement)) changed = true;

    if (runTreeTick(settlement)) changed = true;

    if (runForesterTick(settlement)) changed = true;

    if (runLumberCampTick(settlement)) changed = true;

    if (runFarmTick(settlement)) changed = true;

    if (runHuntTick(settlement)) changed = true;

    if (runFishingTick(settlement)) changed = true;

    if (runSmokehouseTick(settlement)) changed = true;

    if (runWeaverTick(settlement)) changed = true;

    const moves = runAssistantMoves(settlement, getGameConfig());
    if (moves.movedAny) {
        changed = true;
    }

    if (runSawmillTick(settlement)) changed = true;

    if (runQuarryTick(settlement)) changed = true;

    if (runMasonryTick(settlement)) changed = true;

    if (runCharcoalTick(settlement)) changed = true;

    if (runIronMineTick(settlement)) changed = true;

    if (runSmelterTick(settlement)) changed = true;

    if (runBlacksmithTick(settlement)) changed = true;

    if (runGoldMineTick(settlement)) changed = true;

    if (runMintTick(settlement)) changed = true;

    if (runConsumptionTick(settlement, tickIndex)) changed = true;

    if (runConstructionTick(settlement)) changed = true;

    if (runPopulationTick(settlement)) changed = true;

    return changed;
}
